import Vue from 'vue';
import Router from 'vue-router';
import allRouter from './all-Router.js';

Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        ...allRouter
    ]
});

// 全局路由守卫
router.beforeEach((to, from, next) => {
    if(to.matched.length > 0){
        // 检测登陆授权//if(localStorage.length===0)
        const status = localStorage.getItem("status");
        const openId = localStorage.getItem("openId");
        const token = localStorage.getItem("token");
        if(!(status && openId && token && openId!=="" && token!=="" && (status==="1" || status==="0" && (to.name==="userBind"||to.name==="userbind")))){
            if(to.name !== 'checkLogin'){
                return next({name:'checkLogin', query: {menu:to.name}});
            }
        }
        
        window.document.title = to.meta.title;
        return next();
    }
});

// 解决路由访问时出错后 让 当前路由重新刷新
router.onError((error) => {
    const pattern = /Loading chunk (\d)+ failed/g;
    const isChunkLoadFailed = error.message.match(pattern);
    const targetPath = router.history.pending.fullPath;
    if (isChunkLoadFailed) {
        router.replace(targetPath);
    }
});

export default router;
